import { gql } from "@apollo/client";

export const AgencyObjectQuery = gql `
query{
    getAgencyObject {
      response
    }
}
`;

export const getAgencies = gql `
query($input: AgencyFilter!){
  agencies(input: $input) {
  
    agencies {
      _id
      suppliername
      metadata
      createdAt
      updatedAt
    }
    totalCount
    currentPage
    totalPages

  

  }
}
`;


export const getSingleAgency = gql `
query($id: String!){
  agency(_id: $id) {
    _id
    suppliername
    metadata
    isEmployeeAccountExist
    appAccessEmail
  }
}
`;

// ----------------------------------------------------------------------

export const createAgencyMutation = gql `
mutation($input: AgencyInput!){
  createAgency(input: $input) {
    response
  }
}
`;

